import { useAccount } from '@feathr/report_components';

export interface IUsageLimits {
  emailSendLimit: number;
  personsLimit: number;
  enableLimitsBilling: boolean;
}

const EMAIL_SEND_LIMIT_FALLBACK = 10000;
const PERSONS_LIMIT_FALLBACK = 25000;

function useUsageLimits(): IUsageLimits {
  const account = useAccount();
  if (!account?.activePackage) {
    return {
      emailSendLimit: EMAIL_SEND_LIMIT_FALLBACK,
      personsLimit: PERSONS_LIMIT_FALLBACK,
      enableLimitsBilling: false,
    };
  }

  const {
    num_monthly_emails: emailSendLimit,
    num_identified_persons: personsLimit,
    enable_limits_billing: enableLimitsBilling,
  } = account.activePackage;

  return {
    emailSendLimit: emailSendLimit ?? EMAIL_SEND_LIMIT_FALLBACK,
    personsLimit: personsLimit ?? PERSONS_LIMIT_FALLBACK,
    enableLimitsBilling: enableLimitsBilling,
  };
}

export default useUsageLimits;
